<template>
    <div class="banner bng-casino-banner-categories">
        <img
            :src="isMobilePhone ? '/static/banners/casino-home-banner/desktop/crash.jpg' : '/static/banners/casino-home-banner/desktop/crash.jpg'"
        />
        <div class="content">
            <div>{{"components.common.banners.casino-banners.crash-games.msg1" | translate}}</div>
            <div>{{"components.common.banners.casino-banners.crash-games.msg2" | translate}}</div>
        </div>
        <div class="detailed">
            <router-link :to="{ name: 'crash' }">{{"components.common.banners.casino-banners.crash-games.play" | translate}}</router-link>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import isMobile from 'ismobilejs';

export default {
    name: 'casino-banner-crash-games',
    computed: {
        client() {
            return Vue.state.client.get();
        },
        isMobilePhone() {
            return isMobile.phone;
        },
        percent() {
            return this.client && this.client.bonus.cashback && this.client.bonus.cashback.percent;
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/banners/casino-banners/crash-games.vue